'use strict';
const angular = require('angular');

const uiRouter = require('angular-ui-router');

import routes from './cast-contact-vote.routes';

export class CastContactVoteComponent {

  constructor($state, dialogs, $uibModal, Auth, $stateParams, BallotsService, VotingsService, $window, $location, User,
              PropertyService, SettingsService, prompt) {
    'ngInject';

    this.$state = $state;
    this.dialogs = dialogs;
    this.$uibModal = $uibModal;
    this.Auth = Auth;
    this.User = User;
    this.prompt = prompt;
    this.BallotsService = BallotsService;
    this.VotingsService = VotingsService;
    this.PropertyService = PropertyService;
    this.$location = $location;
    this.$stateParams = $stateParams;

    this.back = _=> $window.history.back();

    this.voteId = $stateParams.voteId;
    this.ballotId = $stateParams.id;

    this.selection = [];
    this.writeInSelection = [];

    SettingsService.getByName({name: 'client'}, settings => {
      this.useSuite = settings.data.useSuite;
      this.refreshData();
    });
  }

  addWriteIn() {
    this.prompt({
      title: 'Add Response',
      message: 'Please enter your response below:',
      input: true,
      label: '',
      value: ''
    }).then(writeInResponse => {
      if (!writeInResponse || !writeInResponse.trim()) {
        alert('Your response must not be empty.');
        return;
      }

      let available = [].concat(this.ballot.responses.map(r => r.toLowerCase()), this.writeInSelection.map(r => r.toLowerCase()));
      if (available.indexOf(writeInResponse.trim().toLowerCase()) !== -1) {
        alert('There is already such a response available.');
        return;
      }

      this.writeInSelection.push(writeInResponse.trim());
      this.validateBallot();
    });
  }

  editWriteIn(idx) {
    this.prompt({
      title: 'Edit Response',
      message: 'Please edit your response below:',
      input: true,
      label: '',
      value: this.writeInSelection[idx]
    }).then(writeInResponse => {
      if (!writeInResponse || !writeInResponse.trim()) {
        alert('Your response must not be empty.');
        return;
      }

      let available = [].concat(this.ballot.responses.map(r => r.toLowerCase()), this.writeInSelection.map(r => r.toLowerCase()));
      if (available.indexOf(writeInResponse.trim().toLowerCase()) !== -1) {
        alert('There is already such a response available.');
        return;
      }

      this.writeInSelection[idx] = writeInResponse.trim();
    });

    // do it always, as we ddn't want it to be unchecked at all
    $("input.write-in").eq(idx).prop('checked', true);
  }

  removeWriteIn(idx) {
    this.writeInSelection.splice(idx,1);
    this.validateBallot();
  }

  refreshData() {
    this.Auth.isAdmin(isAdmin => {
      this.isAdmin = isAdmin;

      this.Auth.getCurrentUser(user => {
        this.user = user;
        this.userId = user._id;

        if (this.isAdmin) {
          if (this.ballotId) {
            this.BallotsService.get({id: this.ballotId}, ballot => {
              this.ballot = ballot;
              this.rulesViolation = this.ballot.rules.minResponses !== this.selection.length;
            });
          }
          return;
        }

        this.VotingsService.get({id: this.voteId}, voting => {
          this.alreadyVoted = !!voting.votes.filter(v => v.ballot == this.ballotId && v.voter == this.userId).length;
        });

      }, err => {
        console.log("Could not retrieve users.")
      });


      if (this.ballotId) {
        this.BallotsService.get({id: this.ballotId}, ballot => {
          this.ballot = ballot;
          this.rulesViolation = this.ballot.rules.minResponses !== this.selection.length;
        });
      }

    });

  }

  validateBallot() {

    let total = this.selection.length + this.writeInSelection.length;

    if (total > this.ballot.rules.maxResponses) {
      this.rulesViolation = true;
      this.violation = "Maximum " + this.ballot.rules.maxResponses + " response(s) allowed";
    } else if (total < this.ballot.rules.minResponses) {
      this.violation = "Minimum " + this.ballot.rules.minResponses + " response(s) allowed";
      this.rulesViolation = true;
    } else {
      this.rulesViolation = false;
      this.violation = "";
    }
  }

  toggleSelection(response) {
    let idx = this.selection.indexOf(response);

    // Is currently selected
    if (idx > -1) {
      this.selection.splice(idx, 1);
    }

    // Is newly selected
    else {
      this.selection.push(response);
    }

    this.validateBallot();
  }

  getComposedName(contact) {
    let composedName = "";

    if (contact.lastName && contact.firstName) {

      composedName = contact.firstName;


      if (contact.middleName)
        composedName += " " + contact.middleName;

      composedName += " " + contact.lastName;
    }

    if (contact.company) {
      if (composedName == "")
        composedName += contact.company;
      else
        composedName += " (" + contact.company + ")";
    }

    return composedName || "-";
  }

  castVote() {

    let onSuccess = _ => {
      this.secureStoring = false;
        let dlg = this.dialogs.notify("Success", "Your vote has been cast successfully");
        dlg.result.then(() => {
          this.$location.url("/home");
        });
    };

      if (this.isAdmin) {
        alert('You cannot vote in preview mode!');
        return;
      }

      var that = this;

      let voterId = this.userId;

      var modalInstance = this.$uibModal.open({
        animation: true,
        component: 'castVoteAgree',
        resolve: {
          config: function() {
            return {
              secret: that.ballot.secret,
              username: that.getComposedName(that.user)
            }
          }
        },
        size: 'md'
      });

      modalInstance.result.then(
        function (password) {

          if (!that.ballot.secret) {      /* Non-Secret Vote */

            that.VotingsService.upsertNonSecretVote({id: that.voteId, voterId: voterId, propertyId: 0}, {
              ballotId: that.ballotId,
              responses: [].concat(that.selection, that.writeInSelection),
              type: "evote",
              tz: moment.tz.guess()
            }, onSuccess, err => {
              console.log(err);
            });

          } else {                        /* Secret Vote */

            that.secureStoring = true;

            that.VotingsService.castVote({id: that.voteId, voterId: voterId, propertyId: 0}, {
              ballotId: that.ballotId,
              responses: [].concat(that.selection, that.writeInSelection),
              type: "evote",
              tz: moment.tz.guess(),
              password: password
            }, onSuccess, err => {
              that.secureStoring = false;
              console.log(err);
            });

          }

        },
        function () { /* cancel */ }
      );



  }
}

export default angular.module('conduu.castContactVote', [uiRouter])
  .config(routes)
  .component('castContactVote', {
    template: require('./cast-contact-vote.html'),
    controller: CastContactVoteComponent,
    controllerAs: 'ctrl',
    bindings: {
      mode: '@'
    }
  })
  .name;



// WEBPACK FOOTER //
// ./client/app/cast-vote/contact/cast-contact-vote.component.js